class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);
    this.onMoreButtonClick = this.onMoreButtonClick.bind(this);
    this.bindMoreButtons();
    this.updateFilterGroupTitle = this.updateFilterGroupTitle.bind(this);
    this.bindFilterListeners = this.bindFilterListeners.bind(this);
    this.bindMobileDrawerListeners = this.bindMobileDrawerListeners.bind(this);
    this.handlePriceRangeChange = this.handlePriceRangeChange.bind(this);
    this.bindResetListeners = this.bindResetListeners.bind(this);
    this.handleSortChange = this.handleSortChange.bind(this);
    this.bindSortListeners = this.bindSortListeners.bind(this);

    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
    }, 500);

    const facetForm = this.querySelector('form');
    facetForm.addEventListener('input', this.debouncedOnSubmit.bind(this));

    this.bindSortListeners();
    this.bindFilterListeners();
    this.bindMobileDrawerListeners();
    this.bindPriceRangeListeners();
    this.bindResetListeners();

    const facetWrapper = this.querySelector('#FacetsWrapperDesktop');
    if (facetWrapper) facetWrapper.addEventListener('keyup', onKeyUpEscape);

    // Get initial sort value if not already set
    if (!FacetFiltersForm.currentSortValue) {
      const initialSort = document.querySelector('select[name="sort_by"]')?.value;
      if (initialSort) {
        FacetFiltersForm.currentSortValue = initialSort.replace(/\s*}+$/, '').trim();
      }
    }
  }

  bindFilterListeners() {
    // Add event listeners for all filter inputs - both desktop and mobile
    const allInputs = document.querySelectorAll(
      '.facets__colors input[type="checkbox"], .mobile-facets__list input[type="checkbox"], .mobile-facets__details .facets__colors input[type="checkbox"], .facets__list input[type="checkbox"]'
    );
    allInputs.forEach((input) => {
      input.removeEventListener('change', this.updateFilterGroupTitle);
      input.removeEventListener('change', this.syncFilterStates);
      input.addEventListener('change', this.updateFilterGroupTitle);
      input.addEventListener('change', this.syncFilterStates.bind(this));
    });

    // Also check on page load for any pre-checked inputs
    allInputs.forEach((input) => {
      if (input.checked) {
        this.updateFilterGroupTitle({ target: input });
        this.syncFilterStates({ target: input });
      }
    });
  }

  syncFilterStates(event) {
    const changedInput = event.target;
    const paramName = changedInput?.name;
    const value = changedInput?.value;
    const isChecked = changedInput?.checked;

    // Get all active filters
    const activeFilters = document.querySelectorAll('input[type="checkbox"]:checked');
    const hasActiveFilters = activeFilters.length > 0;

    // Update all filter states
    const allInputs = document.querySelectorAll(
      '.facets__colors input[type="checkbox"], .mobile-facets__list input[type="checkbox"], .mobile-facets__details .facets__colors input[type="checkbox"], .facets__list input[type="checkbox"]'
    );

    allInputs.forEach((input) => {
      const label = input.closest('label');
      if (label) {
        const countMatch =
          label.querySelector('.mobile-facets__label-text')?.textContent.match(/\((\d+)\)/) ||
          label
            .querySelector('.color-dot')
            ?.getAttribute('title')
            ?.match(/\((\d+)\)/);
        const count = parseInt(countMatch?.[1] || '0');

        // Handle disabled state
        if (count === 0 && !hasActiveFilters) {
          //label.classList.add('facet-checkbox--disabled');
          //input.disabled = true;
        } else {
          label.classList.remove('facet-checkbox--disabled', 'mobile-facets__label--disabled', 'disabled');
          input.disabled = false;
        }

        // Handle color dots
        const colorDot = input.nextElementSibling;
        if (colorDot && colorDot.classList.contains('color-dot')) {
          if (input.checked) {
            colorDot.classList.add('selected');
            colorDot.classList.remove('disabled');
          } else {
            colorDot.classList.remove('selected');
            if (count === 0 && !hasActiveFilters) {
              colorDot.classList.add('disabled');
            } else {
              colorDot.classList.remove('disabled');
            }
          }
        }
      }
    });

    // If we have a specific input that changed, sync its state across all forms
    if (paramName && value) {
      const correspondingInputs = document.querySelectorAll(
        `input[type="checkbox"][name="${paramName}"][value="${value}"]`
      );
      correspondingInputs.forEach((input) => {
        if (input !== changedInput) {
          input.checked = isChecked;
        }
      });
    }
  }


  bindMobileDrawerListeners() {
    const mobileDetails = document.querySelectorAll('.mobile-facets__details');
    mobileDetails.forEach((detail) => {
      detail.addEventListener('click', (event) => {
        if (event.target.closest('summary')) {
          // Only handle closing other details, don't prevent default behavior
          const isOpen = detail.hasAttribute('open');

          if (!isOpen) {
            // Close all other details first
            mobileDetails.forEach((otherDetail) => {
              if (otherDetail !== detail) {
                otherDetail.removeAttribute('open');
              }
            });
          }
        }
      });
    });
  }

  bindPriceRangeListeners() {
    const priceRangeInputs = document.querySelectorAll('.mobile-facets__checkbox.price');
    priceRangeInputs.forEach((input) => {
      input.addEventListener('change', this.handlePriceRangeChange.bind(this));

    });
  }

  handlePriceRangeChange(event) {
    const checkbox = event.target;
    const minValue = checkbox.value;
    let maxValue = checkbox.dataset.rangeMax;
    if (!maxValue) {
      const highestPrice = 10000;
      maxValue = highestPrice;
    }

    const currentSortValue = document.querySelector('select[name="sort_by"]')?.value;

    // Uncheck other price range checkboxes
    const otherCheckboxes = document.querySelectorAll('.mobile-facets__checkbox.price');
    otherCheckboxes.forEach((otherBox) => {
      if (otherBox !== checkbox) {
        otherBox.checked = false;
      }
    });

    const forms = document.querySelectorAll('.facets--form');
    forms.forEach((form) => {
      const minInput = form.querySelector(`input[data-range-type="min"]`);
      const maxInput = form.querySelector(`input[data-range-type="max"]`);

      if (maxInput) {
        maxInput.setAttribute("min", minValue);
        const priceRangeComponent = form.querySelector('price-range');


        if (checkbox.checked) {

          minInput.value = minValue;
          // minInput.dispatchEvent(new Event("input", { bubbles: true }));
          minInput.dispatchEvent(new Event("change", { bubbles: true }));

          if (maxInput.value !== maxValue) {
            maxInput.value = maxValue;
            maxInput.dispatchEvent(new Event("change", { bubbles: true }));

          }

        } else {
          minInput.value = minInput.min;
          maxInput.value = maxInput.max;
        }

        // Preserve sort value if it exists
        const sortSelect = form.querySelector('select[name="sort_by"]');
        if (sortSelect && currentSortValue) {
          sortSelect.value = currentSortValue;
        }

        // Update range sliders if they exist
        if (priceRangeComponent) {
          const rangeInputs = priceRangeComponent.querySelectorAll('input[type="range"]');
          if (rangeInputs.length === 2) {
            rangeInputs[0].value = checkbox.checked ? minValue : rangeInputs[0].min;
            rangeInputs[1].value = checkbox.checked ? maxValue || rangeInputs[1].max : rangeInputs[1].max;

            // Update progress bar
            const progress = priceRangeComponent.querySelector('.facets__price-range-progress');
            if (progress) {
              const max = Number(rangeInputs[0].max);
              const left = (Number(rangeInputs[0].value) / max) * 100 + '%';
              const right = 100 - (Number(rangeInputs[1].value) / max) * 100 + '%';
              progress.style.left = left;
              progress.style.right = right;
            }
          }

          // Update number inputs (if present)
          const InputsNumbers = priceRangeComponent.querySelectorAll('input[type="number"]');
          if (InputsNumbers.length === 2) {
            InputsNumbers[0].value = checkbox.checked ? minValue : InputsNumbers[0].min;
            InputsNumbers[1].value = checkbox.checked ? maxValue || InputsNumbers[1].max : InputsNumbers[1].max;
          }
        }
      }
    });
  }


  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    };
    window.addEventListener('popstate', onHistoryChange);
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll('.js-facet-remove').forEach((element) => {
      element.classList.toggle('disabled', disable);
    });
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    FacetFiltersForm.searchParamsPrev = searchParams;
    const sections = FacetFiltersForm.getSections();
    const countContainer = document.getElementById('ProductCount');
    const countContainerDesktop = document.getElementById('ProductCountDesktop');
    document.getElementById('ProductGridContainer').querySelector('.collection').classList.add('loading');
    if (countContainer) {
      countContainer.classList.add('loading');
    }
    if (countContainerDesktop) {
      countContainerDesktop.classList.add('loading');
    }

    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      const filterDataUrl = (element) => element.url === url;

      FacetFiltersForm.filterData.some(filterDataUrl)
        ? FacetFiltersForm.renderSectionFromCache(filterDataUrl, event)
        : FacetFiltersForm.renderSectionFromFetch(url, event);
    });

    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
  }

  static renderSectionFromFetch(url, event) {
    fetch(url)
      .then((response) => response.text())
      .then((responseText) => {
        const html = responseText;
        FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, { html, url }];
        FacetFiltersForm.renderFilters(html, event);
        FacetFiltersForm.renderProductGridContainer(html);
        FacetFiltersForm.renderProductCount(html);
        if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(html.innerHTML);
      });
  }
  static renderSectionFromCache(filterDataUrl, event) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;

    FacetFiltersForm.renderFilters(html, event);
    FacetFiltersForm.renderProductGridContainer(html);
    FacetFiltersForm.renderProductCount(html);
    if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(html.innerHTML);
  }

  static renderProductGridContainer(html) {
    document.getElementById('ProductGridContainer').innerHTML = new DOMParser()
      .parseFromString(html, 'text/html')
      .getElementById('ProductGridContainer').innerHTML;

    document
      .getElementById('ProductGridContainer')
      .querySelectorAll('.scroll-trigger')
      .forEach((element) => {
        element.classList.add('scroll-trigger--cancel');
      });
  }

  static renderProductCount(html) {
    const container = document.getElementById('ProductCount');
    const containerDesktop = document.getElementById('ProductCountDesktop');

    if (!container) return;

    const count = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductCount').innerHTML;
    container.innerHTML = count;
    container.classList.remove('loading');

    if (containerDesktop) {
      containerDesktop.innerHTML = count;
      containerDesktop.classList.remove('loading');
    }
  }

  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');

    const facetDetailsElements = parsedHTML.querySelectorAll(
      '#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter'
    );
    const matchesIndex = (element) => {
      const jsFilter = event ? event.target.closest('.js-filter') : undefined;
      return jsFilter ? element.dataset.index === jsFilter.dataset.index : false;
    };
    const facetsToRender = Array.from(facetDetailsElements).filter((element) => !matchesIndex(element));
    const countsToRender = Array.from(facetDetailsElements).find(matchesIndex);

    facetsToRender.forEach((element) => {
      document.querySelector(`.js-filter[data-index="${element.dataset.index}"]`).innerHTML = element.innerHTML;
    });

    FacetFiltersForm.renderActiveFacets(parsedHTML);
    FacetFiltersForm.renderAdditionalElements(parsedHTML);

    if (countsToRender) FacetFiltersForm.renderCounts(countsToRender, event.target.closest('.js-filter'));

    // Update sort UI before rebinding
    FacetFiltersForm.renderSorting(parsedHTML);

    // Rebind all event listeners after content update
    document.querySelectorAll('facet-filters-form').forEach((form) => {
      // Remove existing instances to prevent duplicate listeners
      const newForm = form.cloneNode(true);
      form.parentNode.replaceChild(newForm, form);

      // Initialize the new form instance
      customElements.upgrade(newForm);
    });
  }

  static renderActiveFacets(html) {
    const activeFacetElementSelectors = ['.active-facets-mobile', '.active-facets-desktop'];

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);
      if (!activeFacetsElement) return;
      document.querySelector(selector).innerHTML = activeFacetsElement.innerHTML;
    });

    FacetFiltersForm.toggleActiveFacets(false);
  }

  static renderAdditionalElements(html) {
    const mobileElementSelectors = ['.mobile-facets__open', '.mobile-facets__count', '.sorting'];

    mobileElementSelectors.forEach((selector) => {
      const newElement = html.querySelector(selector);
      const currentElement = document.querySelector(selector);
      if (!newElement || !currentElement) return;

      if (selector === '.sorting') {
        // For sorting elements, preserve event listeners while updating content
        const newSortSelects = newElement.querySelectorAll('select[name="sort_by"]');
        const currentSortSelects = currentElement.querySelectorAll('select[name="sort_by"]');

        if (newSortSelects.length && currentSortSelects.length) {
          currentSortSelects.forEach((currentSelect, index) => {
            if (newSortSelects[index]) {
              // Store the current event listeners
              const currentListeners = currentSelect.cloneNode(true);

              // Update the HTML and clean up values
              currentSelect.innerHTML = newSortSelects[index].innerHTML;
              Array.from(currentSelect.options).forEach((option) => {
                option.value = option.value.replace(/\s*}+$/, '').trim();
              });

              // Set the value from the new select
              const newValue = newSortSelects[index].value.replace(/\s*}+$/, '').trim();
              currentSelect.value = newValue;

              // Update selected states
              Array.from(currentSelect.options).forEach((option) => {
                option.selected = option.value === newValue;
              });

              // Preserve the original event listeners
              const newSelect = currentListeners.cloneNode(true);
              newSelect.innerHTML = currentSelect.innerHTML;
              newSelect.value = newValue;
              currentSelect.parentNode.replaceChild(newSelect, currentSelect);
            }
          });
        }
      } else {
        currentElement.innerHTML = newElement.innerHTML;
      }
    });

    document.getElementById('FacetFiltersFormMobile').closest('menu-drawer').bindEvents();
  }

  static renderCounts(source, target) {
    const targetElement = target.querySelector('.facets__selected');
    const sourceElement = source.querySelector('.facets__selected');

    const targetElementAccessibility = target.querySelector('.facets__summary');
    const sourceElementAccessibility = source.querySelector('.facets__summary');

    if (sourceElement && targetElement) {
      target.querySelector('.facets__selected').outerHTML = source.querySelector('.facets__selected').outerHTML;
    }

    if (targetElementAccessibility && sourceElementAccessibility) {
      target.querySelector('.facets__summary').outerHTML = source.querySelector('.facets__summary').outerHTML;
    }
  }

  static updateURLHash(searchParams) {
    history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
  }

  static getSections() {
    return [
      {
        section: document.getElementById('product-grid').dataset.id,
      },
    ];
  }

  // createSearchParams(form) {
  //   const formData = new FormData(form);
  //   const searchParams = new URLSearchParams();

  //   // Properly handle multiple values for the same parameter
  //   for (const [key, value] of formData.entries()) {
  //     // Clean up sort_by value if present
  //     if (key === 'sort_by') {
  //       // Remove any trailing } and spaces
  //       const cleanValue = value.replace(/\s*}+$/, '').trim();
  //       searchParams.set(key, cleanValue);
  //     } else {
  //       // Handle other parameters as before
  //       const existingValues = searchParams.getAll(key);
  //       if (!existingValues.includes(value)) {
  //         searchParams.append(key, value);
  //       }
  //     }
  //   }
  //   return searchParams.toString();
  // }

  createSearchParams(form) {
    const formData = new FormData(form);
    const searchParams = new URLSearchParams();

    let minPrice = null;
    let maxPrice = null;

    // Get max possible price dynamically
    const maxPriceInput = form.querySelector(`input[data-range-type="max"]`);
    let maxPossiblePrice = maxPriceInput ? parseFloat(maxPriceInput.getAttribute('max')) : null;

    if (!maxPossiblePrice || isNaN(maxPossiblePrice)) {
      maxPossiblePrice = 10000; // Fallback default if not found
    }

    const defaultPrice = maxPossiblePrice / 2;

    for (const [key, value] of formData.entries()) {
      if (!value) continue; // Ignore empty values

      // Capture min/max price
      if (key === "filter.v.price.gte") minPrice = parseFloat(value);
      if (key === "filter.v.price.lte") maxPrice = parseFloat(value);

      // Handle sorting separately
      if (key === "sort_by") {
        const cleanValue = value.replace(/\s*}+$/, '').trim();
        searchParams.set(key, cleanValue);
      } else {
        searchParams.append(key, value);
      }
    }

    // Remove price filters if they match the default midpoint
    if (minPrice !== null && minPrice === defaultPrice) {
      searchParams.delete("filter.v.price.gte");
    }
    if (maxPrice !== null && maxPrice === defaultPrice) {
      searchParams.delete("filter.v.price.lte");
    }

    return searchParams.toString();
  }

  onSubmitForm(searchParams, event) {
    FacetFiltersForm.renderPage(searchParams, event);
  }

  // onSubmitHandler(event) {
  //   event.preventDefault();
  //   const sortFilterForms = document.querySelectorAll('facet-filters-form form');
  //   const combinedParams = new URLSearchParams();

  //   // Track if we've already added a sort parameter
  //   let hasSortParam = false;

  //   // Gather all parameters from all forms
  //   sortFilterForms.forEach((form) => {
  //     if (
  //       form.id === 'FacetSortForm' ||
  //       form.id === 'FacetFiltersForm' ||
  //       form.id === 'FacetSortDrawerForm' ||
  //       form.id === 'FacetFiltersFormMobile'
  //     ) {
  //       const noJsElements = document.querySelectorAll('.no-js-list');
  //       noJsElements.forEach((el) => el.remove());

  //       // Get form data
  //       const formData = new FormData(form);

  //       // Add each form field to the combined parameters
  //       for (const [key, value] of formData.entries()) {
  //         if (key === 'sort_by') {
  //           // Only add sort parameter once and clean it up
  //           if (!hasSortParam) {
  //             const cleanValue = value.replace(/\s*}+$/, '').trim();
  //             combinedParams.set(key, cleanValue);
  //             hasSortParam = true;
  //           }
  //         } else {
  //           // Handle other parameters as before
  //           const existingValues = combinedParams.getAll(key);
  //           if (!existingValues.includes(value)) {
  //             combinedParams.append(key, value);
  //           }
  //         }
  //       }
  //     }
  //   });

  //   this.onSubmitForm(combinedParams.toString(), event);
  // }

  onSubmitHandler(event) {
    event.preventDefault();
    const sortFilterForms = document.querySelectorAll('facet-filters-form form');
    const combinedParams = new URLSearchParams();

    let hasSortParam = false;

    // Gather all parameters from all forms
    sortFilterForms.forEach((form) => {
      if (
        form.id === 'FacetSortForm' ||
        form.id === 'FacetFiltersForm' ||
        form.id === 'FacetSortDrawerForm' ||
        form.id === 'FacetFiltersFormMobile'
      ) {
        const noJsElements = document.querySelectorAll('.no-js-list');
        noJsElements.forEach((el) => el.remove());

        // Use the updated createSearchParams() function
        const searchParamsString = this.createSearchParams(form);
        const searchParams = new URLSearchParams(searchParamsString);

        // Append all parameters
        searchParams.forEach((value, key) => {
          if (key === 'sort_by') {
            if (!hasSortParam) {
              combinedParams.set(key, value);
              hasSortParam = true;
            }
          } else {
            combinedParams.append(key, value);
          }
        });
      }
    });
    this.onSubmitForm(combinedParams.toString(), event);
  }


  onActiveFilterClick(event) {
    event.preventDefault();
    FacetFiltersForm.toggleActiveFacets();
    const url =
      event.currentTarget.href.indexOf('?') == -1
        ? ''
        : event.currentTarget.href.slice(event.currentTarget.href.indexOf('?') + 1);
    FacetFiltersForm.renderPage(url);
  }

  bindMoreButtons() {
    const moreButtons = this.querySelectorAll('.facets__more-button');
    moreButtons.forEach((button) => {
      button.addEventListener('click', this.onMoreButtonClick);
    });
  }

  onMoreButtonClick(event) {
    const button = event.currentTarget;
    const filterGroup = button.dataset.filterGroup;

    // For Metal, Stone and Styles filters, trigger the mobile drawer
    if (filterGroup === 'Metal' || filterGroup === 'Stone' || filterGroup === 'Styles') {
      // Find and trigger the mobile drawer
      const mobileDrawerButton = document.querySelector('.mobile-facets__open');
      if (mobileDrawerButton) {
        mobileDrawerButton.click();

        // Find and open the corresponding filter in the mobile drawer
        setTimeout(() => {
          const mobileFilter = Array.from(document.querySelectorAll('.mobile-facets__details')).find(
            (detail) => detail.querySelector('.mobile-facets__summary span')?.textContent.trim() === filterGroup
          );
          if (mobileFilter && !mobileFilter.hasAttribute('open')) {
            mobileFilter.querySelector('summary').click();
          }
        }, 300);
      }
      return;
    }

    if (!button.classList.contains('is-open')) {
      button.classList.add('is-open');
      button.setAttribute('aria-expanded', 'true');
    } else {
      button.classList.remove('is-open');
      button.setAttribute('aria-expanded', 'false');
    }
  }
  updateFilterGroupTitle(event) {
    const input = event.target;

    const filterGroup = input.closest('[data-filter-group]');
    if (!filterGroup) return;

    const filterGroupName = filterGroup.dataset.filterGroup;
    const title = document.querySelector(`h3[data-filter-group="${filterGroupName}"]`);
    if (!title) return;

    const selectedValue = input.checked ? input.nextElementSibling.getAttribute('title').split(' (')[0] : '';

    // Clear existing content
    title.innerHTML = '';

    // Add title text wrapped in span
    const titleSpan = document.createElement('span');
    titleSpan.textContent = filterGroupName;
    title.appendChild(titleSpan);

    // Add selected value if exists
    if (selectedValue) {
      const selectedSpan = document.createElement('span');
      selectedSpan.className = 'facets__filter-group-selected';
      selectedSpan.textContent = ' ' + selectedValue;
      title.appendChild(selectedSpan);
    }
  }

  bindResetListeners() {
    const resetButtons = document.querySelectorAll('.mobile-facets__clear, .facets__reset');
    resetButtons.forEach((button) => {
      button.addEventListener('click', async (event) => {
        //event.preventDefault();
        const form = button.closest('form');
        const mobileDetails = form.querySelector('.mobile-facets__details');

        if (mobileDetails || form) {
          // Get the filter type
          const filterType = mobileDetails
            ? mobileDetails.querySelector('.mobile-facets__summary > div > span')?.textContent.trim()
            : form
              .querySelector('.facets__filter-group')
              ?.querySelector('.facets__filter-group-title')
              ?.textContent.split(':')[0]
              ?.trim();

          if (!filterType) return;

          // Reset both mobile and desktop filter groups for this type
          const allFilterGroups = document.querySelectorAll('.mobile-facets__details, .facets__filter-group');
          allFilterGroups.forEach((group) => {
            const groupTitle = group
              .querySelector('.mobile-facets__summary > div > span, .facets__filter-group-title')
              ?.textContent.split(':')[0]
              ?.trim();

            if (groupTitle) {
              // Reset title
              const titleElement = group.querySelector(
                '.mobile-facets__summary > div > span, .facets__filter-group-title'
              );
              if (titleElement) {
                // titleElement.textContent = filterType;
              }

              // Reset all checkboxes and remove disabled states
              group.querySelectorAll('input[type="checkbox"]').forEach((checkbox) => {
                checkbox.checked = false;
                checkbox.disabled = false;

                // Remove disabled state from label
                const label = checkbox.closest('label');
                if (label) {
                  label.classList.remove('facet-checkbox--disabled', 'mobile-facets__label--disabled', 'disabled');
                }

                // Reset color dots if present
                const colorDot = checkbox.nextElementSibling;
                if (colorDot && colorDot.classList.contains('color-dot')) {
                  colorDot.classList.remove('selected', 'disabled');
                }
              });

              // Remove any selected spans
              group.querySelectorAll('.facets__filter-group-selected').forEach((span) => span.remove());
            }
          });

          // Submit the form to update the UI
          const targetForm = form || mobileDetails.closest('form');
          if (targetForm) {
            const formData = new FormData(targetForm);
            const searchParams = new URLSearchParams(formData).toString();

            // Update URL
            history.pushState({ searchParams: '' }, '', window.location.pathname);

            // Render the page with clean params
            FacetFiltersForm.renderPage('', event, false);
          }

          // Re-bind listeners and update states
          this.bindFilterListeners();

          // Force update all filter states after reset
          const dummyEvent = { target: document.querySelector('input[type="checkbox"]') };
          if (dummyEvent.target) {
            this.syncFilterStates(dummyEvent);
          }
        }
      });
    });
  }

  bindSortListeners() {
    const sortSelects = document.querySelectorAll(
      '.sorting-horizontal select[name="sort_by"], .facets select[name="sort_by"], .facets-wrapper select[name="sort_by"]'
    );
    sortSelects.forEach((select) => {
      select.removeEventListener('change', this.handleSortChange);
      select.addEventListener('change', this.handleSortChange);
    });
  }

  handleSortChange(event) {
    event.preventDefault();
    const newValue = event.target.value.trim();

    // Prevent unnecessary updates if the value hasn't changed
    if (FacetFiltersForm.currentSortValue === newValue) {
      return;
    }

    FacetFiltersForm.currentSortValue = newValue;

    // Update all sort selectors to match
    const sortSelects = document.querySelectorAll(
      '.sorting-horizontal select[name="sort_by"], .facets select[name="sort_by"], .facets-wrapper select[name="sort_by"]'
    );

    sortSelects.forEach((select) => {
      // Update the value and selected state for all selectors
      select.value = newValue;
      Array.from(select.options).forEach((option) => {
        option.selected = option.value === newValue;
      });
    });

    // Get all forms that contain sort selectors
    const sortFilterForms = document.querySelectorAll('facet-filters-form form');
    const combinedParams = new URLSearchParams();
    let hasSortParam = false;

    // Gather all parameters from all forms
    sortFilterForms.forEach((form) => {
      if (
        form.id === 'FacetSortForm' ||
        form.id === 'FacetFiltersForm' ||
        form.id === 'FacetSortDrawerForm' ||
        form.id === 'FacetFiltersFormMobile'
      ) {
        const formData = new FormData(form);
        for (const [key, value] of formData.entries()) {
          if (key === 'sort_by') {
            if (!hasSortParam) {
              combinedParams.set(key, newValue);
              hasSortParam = true;
            }
          } else {
            const existingValues = combinedParams.getAll(key);
            if (!existingValues.includes(value)) {
              combinedParams.append(key, value);
            }
          }
        }
      }
    });

    // Convert parameters to string
    const searchParams = combinedParams.toString();

    // Update URL and render page
    history.pushState({ searchParams }, '', `${window.location.pathname}?${searchParams}`);
    FacetFiltersForm.renderPage(searchParams, event);
  }

  static renderSorting(html) {
    const htmlContainer = document.createElement('div');
    htmlContainer.innerHTML = html;

    // Get current sort elements
    const currentSortElements = document.querySelectorAll('select[name="sort_by"]');

    if (currentSortElements.length > 0) {
      // Use the static currentSortValue to update all selectors
      const currentValue = FacetFiltersForm.currentSortValue;

      if (currentValue) {
        currentSortElements.forEach((select, index) => {
          // Store the current overlay state
          const parentContainer = select.closest('.collection');
          const wasLoading = parentContainer?.classList.contains('loading');

          // Get the new select element from the parsed HTML
          const newSelect = htmlContainer.querySelector('select[name="sort_by"]');
          if (newSelect) {
            // Update the options HTML to match the new select
            select.innerHTML = newSelect.innerHTML;
          }

          // Update each option's value and selected state
          Array.from(select.options).forEach((option) => {
            const optionValue = option.value.trim();
            if (optionValue === currentValue) {
              option.setAttribute('selected', 'selected');
              option.selected = true;
            } else {
              option.removeAttribute('selected');
              option.selected = false;
            }
          });

          // Set the select value
          select.value = currentValue;

          // Restore the overlay state
          if (wasLoading && parentContainer) {
            parentContainer.classList.add('loading');
          }
        });

        // Ensure the label text remains "Sort by:"
        const sortLabels = document.querySelectorAll('.facet-filters__label');
        sortLabels.forEach((label) => {
          // Only update if it's not already "Sort by:"
          if (!label.querySelector('label[for="SortBy"]')) {
            label.innerHTML = '<label for="SortBy">Sort by:</label>';
          }
        });
      }
    }

    // Rebind sort listeners after updating
    document.querySelectorAll('facet-filters-form').forEach((form) => {
      if (form.bindSortListeners) {
        form.bindSortListeners();
      }
    });
  }
}

// Add static property for current sort value
FacetFiltersForm.currentSortValue = null;
FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define('facet-filters-form', FacetFiltersForm);
FacetFiltersForm.setListeners();

// class PriceRange extends HTMLElement {
//   constructor() {
//     super();
//     this.inputs = this.querySelectorAll('input[type="number"]');
//     this.rangeInputs = this.querySelectorAll('input[type="range"]');
//     this.progress = this.querySelector('.facets__price-range-progress');
//     this.minValue = Number(this.rangeInputs[0].min);
//     this.maxValue = Number(this.rangeInputs[1].max);

//     this.setInitialValues();

//     //this.inputs.forEach((element) => element.addEventListener('change', this.onInputChange.bind(this)));
//     this.inputs.forEach((element) => {
//       element.addEventListener('input', this.onInputChange.bind(this));
//       element.addEventListener('change', this.onInputChange.bind(this));
//     });

//     this.rangeInputs.forEach((element) => {
//       element.addEventListener('input', this.onRangeInput.bind(this));
//       element.addEventListener('change', this.onRangeChange.bind(this));
//     });

//     //this.setMinAndMaxValues();
//     this.updateProgress();
//   }

//   setInitialValues() {
//     const [minInput, maxInput] = this.inputs;
//     const [minRange, maxRange] = this.rangeInputs;

//     // Update the initial range inputs with the corresponding values
//     minRange.value = this.minValue;
//     maxRange.value = this.maxValue;

//     minInput.value = minRange.value;
//     maxInput.value = maxRange.value;

//     minInput.setAttribute('max', maxRange.max);
//     maxInput.setAttribute('min', minRange.min);

//     console.log('Initialized values:', minInput.value, maxInput.value);
//     console.log('Range Values:', minRange.value, maxRange.value);
//   }

//   onInputChange(event) {
//     this.adjustToValidValues(event.currentTarget);
//     this.setMinAndMaxValues();
//     this.updateRangeFromInputs(event);
//     this.updateProgress();
//   }

//   onRangeInput(event) {
//     const isMin = event.currentTarget.dataset.rangeType === 'min';
//     const value = event.currentTarget.value;

//     if (isMin) {
//       this.inputs[0].value = value;
//     } else {
//       this.inputs[1].value = value;
//     }

//     this.updateProgress();
//   }

//   onRangeChange(event) {
//     this.onInputChange(event);
//   }

//   updateRangeFromInputs(event) {
//     const [minInput, maxInput] = this.inputs;
//     const [minRange, maxRange] = this.rangeInputs;

//     minRange.value = minInput.value || minInput.min;
//     maxRange.value = maxInput.value || maxInput.max;

//     if (event.target.id === 'Filter-Price-GTE') {
//       document.querySelector(`[data-range-type="min"]`).value = event.target.value;
//       document.querySelector(`[data-range-type="min"]`).dispatchEvent(new Event("input"), { bubbles: true });
//     } else if (event.target.id === 'Filter-Price-LTE') {
//       document.querySelector(`[data-range-type="max"]`).value = event.target.value;
//       document.querySelector(`[data-range-type="max"]`).dispatchEvent(new Event("input"), { bubbles: true });
//     }
//   }

//   updateProgress() {
//     if (!this.progress) return;

//     const [minRange, maxRange] = this.rangeInputs;
//     console.log(this.rangeInputs, "range=>")
//     const minValue = Number(minRange.value);
//     const maxValue = Number(maxRange.value);
//     const rangeMax = Number(minRange.max);
//     console.log(minValue, "minValue==>")
//     console.log(rangeMax, "rangeMax==>")
//     console.log(maxValue, "maxValue==>")
//     const leftPercentage = Math.round((minValue / rangeMax) * 100);
//     const rightPercentage = Math.round(100 - (maxValue / rangeMax) * 100);

//     this.progress.style.left = `${leftPercentage}%`;
//     this.progress.style.right = `${rightPercentage}%`;

//     console.log('Progress:', leftPercentage, rightPercentage);

//   }

//   setMinAndMaxValues() {
//     // const inputs = this.querySelectorAll('input');
//     // const minInput = inputs[0];
//     // const maxInput = inputs[1];
//     // if (maxInput.value) minInput.setAttribute('max', maxInput.value);
//     // if (minInput.value) maxInput.setAttribute('min', minInput.value);
//     // if (minInput.value === '') maxInput.setAttribute('min', 0);
//     // if (maxInput.value === '') minInput.setAttribute('max', maxInput.getAttribute('max'));

//     const [minInput, maxInput] = this.inputs;

//     if (minInput && maxInput) {
//       if (maxInput.value) minInput.setAttribute('max', maxInput.value);
//       if (minInput.value) maxInput.setAttribute('min', minInput.value);
//       if (minInput.value === '') maxInput.setAttribute('min', 0);
//       if (maxInput.value === '') minInput.setAttribute('max', maxInput.getAttribute('max'));
//     }

//   }

//   adjustToValidValues(input) {
//     const value = Number(input.value);
//     const min = Number(input.getAttribute('min'));
//     const max = Number(input.getAttribute('max'));

//     if (value < min) input.value = min;
//     if (value > max) input.value = max;
//   }
// }

class PriceRange extends HTMLElement {
  constructor() {
    super();
    this.inputs = this.querySelectorAll('input[type="number"]');
    this.rangeInputs = this.querySelectorAll('input[type="range"]');
    this.progress = this.querySelector('.facets__price-range-progress');
    this.isInitialized = false;

    this.inputs.forEach((element) => {
      element.addEventListener('input', this.onInputChange.bind(this));
      element.addEventListener('change', this.onInputChange.bind(this));
    });

    this.rangeInputs.forEach((element) => {
      element.addEventListener('input', this.onRangeInput.bind(this));
      element.addEventListener('change', this.onRangeChange.bind(this));
    });

    // Update the progress bar dynamically
    this.updateProgress();
  }


  // Handle input changes for the number inputs
  onInputChange(event) {
    this.adjustToValidValues(event.currentTarget);
    //this.setMinAndMaxValues();
    this.updateRangeFromInputs(event);
    this.updateProgress();
  }

  // Handle range input changes
  onRangeInput(event) {
    const isMin = event.currentTarget.dataset.rangeType === 'min';
    const value = event.currentTarget.value;

    if (isMin) {
      this.inputs[0].value = value;
    } else {
      this.inputs[1].value = value;
    }

    this.updateProgress();
  }

  // Handle range input change event (input or change)
  onRangeChange(event) {
    this.onInputChange(event);
  }

  // Update range values based on input changes
  updateRangeFromInputs() {
    const [minInput, maxInput] = this.inputs;
    const [minRange, maxRange] = this.rangeInputs;

    minRange.value = minInput.value || minInput.min;
    maxRange.value = maxInput.value || maxInput.max;
  }

  updateProgress() {
    if (!this.progress) return;

    const [minInput, maxInput] = this.inputs;
    const [minRange, maxRange] = this.rangeInputs;

    minRange.value = minInput.value || minInput.min;
    maxRange.value = maxInput.value || maxInput.max;
    const minValue = Number(minRange.value);
    const maxValue = Number(maxRange.value);
    const rangeMax = Number(minRange.max);

    // Calculate left and right percentages for progress bar
    const leftPercentage = Math.round((minValue / rangeMax) * 100);
    const rightPercentage = Math.round(100 - (maxValue / rangeMax) * 100);

    this.progress.style.left = `${leftPercentage}%`;
    this.progress.style.right = `${rightPercentage}%`;
  }

  // Set valid min/max values based on user input
  // setMinAndMaxValues() {
  //   const [minInput, maxInput] = this.inputs;

  //   if (minInput && maxInput) {
  //     if (maxInput.value) minInput.setAttribute('max', maxInput.value);
  //     if (minInput.value) maxInput.setAttribute('min', minInput.value);
  //     if (minInput.value === '') maxInput.setAttribute('min', 0);
  //     if (maxInput.value === '') minInput.setAttribute('max', maxInput.getAttribute('max'));
  //   }
  // }

  // Ensure input values are within valid range
  adjustToValidValues(input) {
    const value = Number(input.value);
    const min = Number(input.getAttribute('min'));
    const max = Number(input.getAttribute('max'));

    if (value < min) input.value = min;
    if (value > max) input.value = max;
  }
}


customElements.define('price-range', PriceRange);

class FacetRemove extends HTMLElement {
  constructor() {
    super();
    const facetLink = this.querySelector('a');
    facetLink.setAttribute('role', 'button');
    facetLink.addEventListener('click', this.closeFilter.bind(this));
    facetLink.addEventListener('keyup', (event) => {
      event.preventDefault();
      if (event.code.toUpperCase() === 'SPACE') this.closeFilter(event);
    });
  }

  closeFilter(event) {
    event.preventDefault();
    const form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');
    form.onActiveFilterClick(event);
  }
}

customElements.define('facet-remove', FacetRemove);

class FacetFilters extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
    }, 500);

    const facetForm = this.querySelector('form');
    if (facetForm) facetForm.addEventListener('input', this.debouncedOnSubmit.bind(this));

    const facetWrapper = this.querySelector('#FacetsWrapperDesktop');
    if (facetWrapper) facetWrapper.addEventListener('keyup', onKeyUpEscape);

    this.bindMoreButtonEvents();
  }

  static setClasses() {
    const moreButtons = document.querySelectorAll('.facets__more-button');
    moreButtons.forEach((button) => {
      const colors = button.closest('.facets__colors');
      const dots = colors.querySelectorAll('.facets__color-item');
      const visibleCount = Array.from(dots).filter((dot) => !dot.classList.contains('hidden')).length;
      const totalCount = dots.length;
      const countElement = button.querySelector('.color-dot');

      if (button.classList.contains('is-open')) {
        countElement.textContent = '';
      } else {
        const remainingCount = totalCount - visibleCount;
        if (remainingCount > 0) {
          countElement.textContent = `+${remainingCount}`;
        }
      }
    });
  }

  bindMoreButtonEvents() {
    const moreButtons = this.querySelectorAll('.facets__more-button');
    moreButtons.forEach((button) => {
      button.addEventListener('click', (event) => {
        event.preventDefault();
        const isOpen = button.classList.contains('is-open');
        const colors = button.closest('.facets__colors');

        if (!isOpen) {
          button.classList.add('is-open');
          button.setAttribute('aria-expanded', 'true');
        } else {
          button.classList.remove('is-open');
          button.setAttribute('aria-expanded', 'false');
        }

        FacetFilters.setClasses();
      });
    });

    // Initial setup
    FacetFilters.setClasses();
  }
}
